import React from 'react'
import { NavLink, useParams } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { Translate } from 'react-localize-redux'
import { Box, Button, Typography } from '@material-ui/core'
import { SubLink } from 'containers'
import useTeamFeature from 'hooks/useTeamFeature'
import TeaserChip from 'components/Teaser/TeaserChip'
import LockIconComponent from 'components/UpgradeMembership/LockIconComponent'
import useFeatureAccessGuard from 'hooks/useFeatureAccessGuard'
import {
  ACTIVITIES_ROUTE,
  TRAINING_PACKAGE_CREATE_ROUTE,
} from 'constants/routes'
import TEAM_FEATURE_FLAGS from 'constants/teamFeatureFlags'

const useStyles = makeStyles((theme) => ({
  navigation: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 15,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  navList: {
    listStyle: 'none',
    padding: 0,
    display: 'flex',
  },
  navItem: {
    paddingRight: '35px',
  },
  link: {
    color: 'gray',
  },
  button: {
    margin: theme.spacing(0, 1),
  },
}))

const Navigation = () => {
  const { teamUuid, seasonId } = useParams()
  const baseRoute = `/team/${teamUuid}/season/${seasonId}`
  const classes = useStyles()
  const featureGuard = useFeatureAccessGuard()

  const { enabled: hasTrainingPackagesEnabled } = useTeamFeature(
    TEAM_FEATURE_FLAGS.training_packages_enabled
  )
  const { enabled: hasActivitiesEnabled } = useTeamFeature(
    TEAM_FEATURE_FLAGS.activities_enabled
  )

  return (
    <>
      <nav className={classes.navigation}>
        <ul className={classes.navList}>
          <li className={classes.navItem}>
            <NavLink
              to={`${baseRoute}${ACTIVITIES_ROUTE}`}
              className={classes.link}
            >
              <Typography variant="h3" component="h3">
                <Translate id="drills.activities" />
                {!hasActivitiesEnabled && <TeaserChip />}
              </Typography>
            </NavLink>
          </li>
          <li>
            <Typography variant="h3" component="h3">
              <Translate id="navbar.training_packages" />
              {!hasTrainingPackagesEnabled && <TeaserChip />}
            </Typography>
          </li>
        </ul>
        <Box>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            {...(!hasTrainingPackagesEnabled
              ? {
                  onClick: () => featureGuard(),
                }
              : {
                  component: SubLink,
                  to: TRAINING_PACKAGE_CREATE_ROUTE,
                })}
            endIcon={
              !hasTrainingPackagesEnabled ? (
                <LockIconComponent context="primaryButton" />
              ) : null
            }
          >
            <Translate id="training.create-training-packages" />
          </Button>
        </Box>
      </nav>
    </>
  )
}

export default Navigation
